import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, SvgIcon } from '@mui/material';

export const AlertIconContainer = styled(SvgIcon, {
  shouldForwardProp: (prop) => prop !== 'showIcon',
})(({ showIcon }) => ({
  width: 12,
  height: 13,
  position: 'absolute',
  right: 10,
  margin: 0,
  visibility: showIcon ? 'visible' : 'hidden',
}));

export const IconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'alertType',
})(({ theme, alertType }) => ({
  width: 12,
  height: 13,
  color:
    alertType === 'error'
      ? theme.palette.colors.down
      : theme.palette.colors.highlight,
  background: 'none',
}));
